<template>
  <div class="mobile-floating-bar">
    <!-- 위: 장점 롤링 -->
    <div class="bar-top">
      <div class="rolling-strengths">
        <span class="rolling-item" v-for="(item, i) in strengthList" :key="i"
          :style="{ animationDelay: (i * 3) + 's', animationDuration: (strengthList.length * 3) + 's' }">{{ item }}</span>
      </div>
    </div>

    <!-- 아래: 전화 + 방문예약 -->
    <div class="bar-bottom">
      <a href="tel:1533-9770" class="bar-btn bar-phone">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.49a1 1 0 01-1 1C10.07 22 2 13.93 2 3.01a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/>
        </svg>
        <span class="phone-number">1533-9770</span>
      </a>
      <div class="bar-divider"></div>
      <button class="bar-btn bar-register" @click="openRegister">
        <span class="register-main">방문예약</span>
        <span class="rolling-sub">
          <span class="rolling-sub-item" v-for="(item, i) in strengthListBottom" :key="i"
            :style="{ animationDelay: (i * 3) + 's', animationDuration: (strengthListBottom.length * 3) + 's' }">{{ item }}</span>
        </span>
      </button>
    </div>
  </div>

  <!-- 방문예약 폼 -->
  <transition name="register-popup">
    <div v-if="showRegister" class="register-overlay" @click.self="closeRegister">
      <div class="register-modal register-fullform">
        <div class="register-header">
          <h3 class="register-title">방문예약</h3>
          <button class="register-close" @click="closeRegister">
            <span></span>
            <span></span>
          </button>
        </div>

        <div class="register-body" v-if="!isSubmitted">
          <div class="register-coupon-row">
            <p class="register-desc">
              관심을 가져주셔서 감사합니다.<br/>
              분양정보를 빠르게 알아보세요
            </p>
          </div>

          <form @submit.prevent="submitForm" class="register-form">
            <div class="form-group">
              <label class="form-label">이름 <span class="required">*</span></label>
              <input
                v-model="formData.name"
                type="text"
                class="form-input"
                placeholder="이름을 입력해주세요"
                required
              />
            </div>

            <div class="form-group">
              <label class="form-label">연락처 <span class="required">*</span></label>
              <div class="phone-inputs">
                <input
                  ref="phone1"
                  v-model="formData.phone1"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="010"
                  maxlength="3"
                  required
                  @input="onPhoneInput('phone1', 3, 'phone2')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="phone2"
                  v-model="formData.phone2"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="0000"
                  maxlength="4"
                  required
                  @input="onPhoneInput('phone2', 4, 'phone3')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="phone3"
                  v-model="formData.phone3"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="0000"
                  maxlength="4"
                  required
                  @input="onPhoneInput('phone3', 4, null)"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">원하시는 방문일 <span class="required">*</span></label>
              <div class="date-stack">
                <div class="date-wrap">
                  <input type="date" v-model="formData.visitDate" :min="todayStr"
                         :disabled="formData.consultLater" class="form-date" />
                  <span v-if="!formData.visitDate && !formData.consultLater" class="date-placeholder">📅 방문일 선택</span>
                </div>
                <select v-model="formData.visitTime" :disabled="formData.consultLater" class="form-select">
                  <option value="" disabled>⏰ 방문시간 선택</option>
                  <option v-for="t in visitTimes" :key="t" :value="t">{{ t }}</option>
                </select>
              </div>
            </div>

            <div class="form-group agreement">
              <div class="agreement-header">
                <label class="checkbox-label">
                  <input
                    v-model="formData.agree"
                    type="checkbox"
                    class="checkbox-input"
                    required
                  />
                  <span class="checkbox-custom"></span>
                  <span class="checkbox-text">개인정보 수집 및 이용 동의 <span class="required">*</span></span>
                </label>
                <button type="button" class="toggle-btn" @click="showPrivacy = !showPrivacy">
                  {{ showPrivacy ? '닫기' : '보기' }}
                </button>
              </div>
              <div class="privacy-content" :class="{ visible: showPrivacy }">
                <p>
                  <strong>1. 수집하는 개인정보 항목</strong><br />이름, 연락처
                </p>
                <p>
                  <strong>2. 수집 및 이용 목적</strong><br />분양 관련 상담 및 정보 제공
                </p>
                <p>
                  <strong>3. 보유 및 이용 기간</strong><br />수집일로부터 1년간 보관 후 파기
                </p>
              </div>
            </div>

            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              <span v-if="!isSubmitting">방문예약 신청</span>
              <span v-else>전송 중...</span>
            </button>
          </form>
        </div>

        <!-- 성공 -->
        <div v-else class="register-success">
          <div class="success-icon">✓</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
          <button @click="resetForm" class="reset-btn">닫기</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MobileFloatingBar',
  data() {
    return {
      showRegister: false,
      showPrivacy: false,
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDate: '',
        visitTime: '',
        consultLater: false,
        agree: false
      },
      visitTimes: [
        '10:00', '10:30', '11:00', '11:30',
        '12:00', '12:30', '13:00', '13:30',
        '14:00', '14:30', '15:00', '15:30',
        '16:00', '16:30', '17:00', '17:30'
      ],
      strengthList: [
        '걸어서 누리는 명문 교육인프라',
        '농수산물도매시장역 초역세권',
        '10분대로 만나는 중심 생활환경',
        '자연을 곁에 둔 도심 속 힐링특권',
        '평촌의 변화를 앞서 누릴 특급 비전',
        '롯데캐슬 브랜드 독보적 프리미엄'
      ]
    }
  },
  beforeUnmount() {
    window.removeEventListener('open-register-popup', this.openRegister)
  },
  computed: {
    strengthListBottom() {
      return [...this.strengthList.slice(1), this.strengthList[0]]
    },
    todayStr() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  },
  watch: {
    '$route.query.popup'(val) {
      if (val === '1') {
        this.$nextTick(() => {
          this.openRegister()
          this.$router.replace({ path: this.$route.path, query: {} })
        })
      }
    }
  },
  mounted() {
    window.addEventListener('open-register-popup', this.openRegister)
    if (this.$route.query.popup === '1') {
      this.$nextTick(() => {
        this.openRegister()
        this.$router.replace({ path: this.$route.path, query: {} })
      })
    }
  },
  methods: {
    openRegister() {
      this.showRegister = true
      document.body.style.overflow = 'hidden'
    },
    closeRegister() {
      this.showRegister = false
      document.body.style.overflow = ''
    },
    toggleConsultLater() {
      this.formData.consultLater = !this.formData.consultLater
      if (this.formData.consultLater) {
        this.formData.visitDate = ''
        this.formData.visitTime = ''
      }
    },
    formatVisitDate(dateStr) {
      if (!dateStr) return ''
      const days = ['일','월','화','수','목','금','토']
      const d = new Date(dateStr)
      const y = dateStr.slice(0, 4)
      const m = dateStr.slice(5, 7)
      const dd = dateStr.slice(8, 10)
      return `${y}.${m}.${dd}(${days[d.getDay()]})`
    },
    async submitForm() {
      if (!this.formData.consultLater) {
        if (!this.formData.visitDate || !this.formData.visitTime) {
          alert('방문일과 시간을 선택하거나 "상담 후 결정"을 선택해주세요.')
          return
        }
      }
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      const consultTime = this.formData.consultLater
        ? '상담 후 결정'
        : `${this.formatVisitDate(this.formData.visitDate)} ${this.formData.visitTime}`
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          consultTime,
          source: 'website'
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_5a3399ef72b5'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDate: '',
        visitTime: '',
        consultLater: false,
        agree: false
      }
      this.isSubmitted = false
      this.showPrivacy = false
      this.closeRegister()
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    }
  }
}
</script>

<style scoped>
.mobile-floating-bar {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}

/* 위: 사업계획 승인완료 */
.bar-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 20px;
  background: #f0efe2;
  overflow: hidden;
}

.open-text {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 18px;
  font-weight: 800;
  color: var(--primary, #3f3536);
  letter-spacing: -0.02em;
}

.rolling-strengths {
  position: relative;
  height: 22px;
  overflow: hidden;
  width: 100%;
  max-width: 360px;
}

.rolling-item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  white-space: nowrap;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 800;
  color: var(--primary, #3f3536);
  letter-spacing: -0.02em;
  line-height: 22px;
  opacity: 0;
  animation: strengthRoll 18s linear infinite;
}

@keyframes strengthRoll {
  0% { opacity: 0; transform: translateY(10px); }
  2% { opacity: 1; transform: translateY(0); }
  13% { opacity: 1; transform: translateY(0); }
  16% { opacity: 0; transform: translateY(-10px); }
  100% { opacity: 0; }
}

/* 아래: 전화 + 방문예약 */
.bar-bottom {
  display: flex;
  align-items: stretch;
  background: var(--primary, #2e2823);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.bar-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 12px;
  text-decoration: none;
  color: #fff;
  min-height: 48px;
  transition: background 0.2s ease;
}

.bar-btn:active {
  background: rgba(255, 255, 255, 0.1);
}

.bar-divider {
  width: 1px;
  background: rgba(255, 255, 255, 0.25);
  margin: 10px 0;
  flex-shrink: 0;
}

.phone-number {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
}

.bar-register {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
  background: transparent;
  border: none;
  color: #fff;
  flex-direction: column;
  gap: 2px;
}

.register-main {
  font-size: 15px;
  font-weight: 700;
  animation: bounce1 2.5s ease-in-out infinite;
}

.register-sub {
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 0;
  animation: bounce2 2.5s ease-in-out infinite;
  animation-delay: 0.3s;
}

.rolling-sub {
  position: relative;
  display: block;
  height: 14px;
  width: 100%;
  max-width: 220px;
  overflow: hidden;
}

.rolling-sub-item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  white-space: nowrap;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 10px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0;
  line-height: 14px;
  opacity: 0;
  animation: strengthRoll 18s linear infinite;
}

@keyframes bounce1 {
  0%, 100% { transform: translateY(0); }
  15% { transform: translateY(-6px); }
  30% { transform: translateY(0); }
}

@keyframes bounce2 {
  0%, 100% { transform: translateY(0); }
  15% { transform: translateY(-5px); }
  30% { transform: translateY(0); }
}

/* ===== 방문예약 팝업 ===== */
.register-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2100;
  align-items: center;
  justify-content: center;
}

.register-modal {
  background: #fff;
  width: 100%;
  max-height: 90vh;
  border-radius: 20px 20px 0 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.register-modal input,
.register-modal select,
.register-modal button,
.register-modal textarea {
  box-sizing: border-box;
}

.register-modal.register-fullform {
  width: 92%;
  max-width: 400px;
  max-height: 85vh;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.register-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.register-title {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
}

.register-close {
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
}

.register-close span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 2px;
  background: #666;
}

.register-close span:first-child {
  transform: translate(-50%, -50%) rotate(45deg);
}

.register-close span:last-child {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.register-body {
  padding: 24px;
}

.register-coupon-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}

.register-desc {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 14px;
  color: #888;
  line-height: 1.7;
  margin: 0;
  text-align: left;
}

.register-form .form-group {
  margin-bottom: 20px;
}

.register-form .form-label {
  display: block;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.required {
  color: var(--primary, #3f3536);
}

.register-form .form-input {
  width: 100%;
  padding: 14px 16px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.register-form .form-input:focus {
  border-color: var(--primary, #3f3536);
}

.register-form .form-input::placeholder {
  color: #bbb;
}

.visit-inputs {
  display: flex;
  gap: 8px;
}

.visit-field-wrap {
  flex: 1;
  position: relative;
}

.visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.visit-inputs .form-input {
  padding-left: 40px !important;
}

.visit-inputs select.form-input {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
  cursor: pointer;
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-field {
  flex: 1;
  text-align: center;
}

.phone-dash {
  color: #999;
  font-size: 16px;
  flex-shrink: 0;
}

.date-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.date-wrap {
  position: relative;
  width: 100%;
}

.form-date {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 14px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.form-date:focus { border-color: var(--primary, #3f3536); }

.form-date:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background-color: #f0f0f0;
}

.date-placeholder {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: #999;
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
  background: #fafafa;
  padding-right: 8px;
}

.form-select {
  width: 100%;
  padding: 14px 36px 14px 14px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.form-select:focus { border-color: var(--primary, #3f3536); }

.form-select:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background-color: #f0f0f0;
}

.later-btn {
  margin-top: 10px;
  width: 100%;
  padding: 13px;
  background: #fafafa;
  border: 1px dashed #ccc;
  border-radius: 8px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 14px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}

.later-btn.active {
  background: var(--primary, #3f3536);
  border-style: solid;
  border-color: var(--primary, #3f3536);
  color: #fff;
  font-weight: 800;
}

/* 동의 */
.agreement {
  margin-bottom: 24px;
}

.agreement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 4px;
  background: #fff;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-custom {
  background: var(--primary, #3f3536);
  border-color: var(--primary, #3f3536);
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 11px;
}

.checkbox-text {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  color: #333;
}

.toggle-btn {
  background: none;
  border: none;
  font-size: 12px;
  color: #888;
  cursor: pointer;
  text-decoration: underline;
}

.privacy-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #f5f5f5;
  border-radius: 8px;
}

.privacy-content.visible {
  max-height: 200px;
  padding: 16px;
}

.privacy-content p {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.privacy-content p:last-child {
  margin-bottom: 0;
}

.privacy-content strong {
  color: #333;
}

/* 제출 */
.submit-btn {
  width: 100%;
  padding: 16px;
  background: var(--primary, #3f3536);
  border: none;
  border-radius: 10px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}

.submit-btn:active:not(:disabled) {
  background: var(--primary-dark, #2a2324);
}

.submit-btn:disabled {
  opacity: 0.6;
}

/* 성공 */
.register-success {
  padding: 48px 24px;
  text-align: center;
}

.success-icon {
  width: 60px;
  height: 60px;
  border: 2px solid var(--primary, #3f3536);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: var(--primary, #3f3536);
  margin: 0 auto 20px;
}

.register-success h3 {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.register-success p {
  font-size: 14px;
  color: #888;
  margin-bottom: 28px;
}

.reset-btn {
  padding: 12px 40px;
  background: var(--primary, #3f3536);
  border: none;
  border-radius: 10px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

/* 팝업 애니메이션 */
.register-popup-enter-active {
  transition: opacity 0.3s ease;
}

.register-popup-enter-active .register-modal {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease;
}

.register-popup-leave-active {
  transition: opacity 0.25s ease;
}

.register-popup-leave-active .register-modal {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.register-popup-enter-from {
  opacity: 0;
}

.register-popup-enter-from .register-modal.register-fullform {
  transform: scale(0.9);
  opacity: 0;
}

.register-popup-leave-to {
  opacity: 0;
}

.register-popup-leave-to .register-modal.register-fullform {
  transform: scale(0.9);
  opacity: 0;
}

/* PC에서는 바를 화면 전체 폭으로 두되, 버튼은 가운데로 모음 */
@media (min-width: 769px) {
  .bar-bottom {
    justify-content: center;
    gap: 24px;
  }
  .bar-btn {
    flex: 0 0 auto;
    min-width: 200px;
  }
}
</style>
